import { computed, ref } from "vue";
import {
  clearConsent,
  getConsent,
  hasAnalyticsConsent,
  isAnalyticsFeatureEnabled,
  isPrivacyBannerEnabled,
  setConsent,
  shouldShowBanner
} from "@/services/consentService";

const bannerOpen = ref(false);
const initialized = ref(false);

function syncBannerVisibility() {
  if (!isPrivacyBannerEnabled()) {
    bannerOpen.value = false;
    return;
  }

  bannerOpen.value = shouldShowBanner();
}

function initCookieConsent() {
  if (initialized.value) {
    return;
  }

  initialized.value = true;
  syncBannerVisibility();

  if (typeof window !== "undefined") {
    window.addEventListener("engram:consent-updated", syncBannerVisibility);
  }
}

export function openCookieConsentBanner() {
  if (!isPrivacyBannerEnabled()) {
    return;
  }

  bannerOpen.value = true;
}

export function closeCookieConsentBanner() {
  bannerOpen.value = false;
}

export function useCookieConsent() {
  initCookieConsent();

  const consent = computed(() => getConsent());

  return {
    bannerOpen,
    consent,
    getConsent,
    setConsent,
    clearConsent,
    hasAnalyticsConsent,
    shouldShowBanner,
    isAnalyticsFeatureEnabled,
    acceptAnalytics: () => {
      const next = setConsent({ analytics: true });
      bannerOpen.value = false;
      return next;
    },
    declineAnalytics: () => {
      const next = setConsent({ analytics: false });
      bannerOpen.value = false;
      return next;
    },
    openBanner: openCookieConsentBanner,
    closeBanner: closeCookieConsentBanner
  };
}
